import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { useTranslation } from "react-i18next";
import { PromotionPackageStyled } from "./styled";

const PromotionPackage = ({ theme_standard, time_to_use, used }) => {
  const { t } = useTranslation(["common"]);
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <PromotionPackageStyled className={customClass}>
      <div className="promo_title">Promotion / Package</div>
      <div className="promo_sub_title">My Promotion</div>
      <div className="row_promo">
        <div className="row_left">
          ท่านได้รับการจูนเปียโนฟรี {time_to_use} ครั้ง
        </div>
        <div className="row_right">{t("Used {{count}} times", { ns: "common", count: used })}</div>
      </div>
    </PromotionPackageStyled>
  );
};

PromotionPackage.propTypes = {};

export default PromotionPackage;
